module.exports = __webpack_public_path__ + "static/media/vnpay.0f5db1db.svg";